export interface StatementGenerateFormValues {
  endDate: Date | undefined;
  owingOver?: number;
  creditOver?: number;
  valueFilter?: boolean;
  accountContactIds?: string[];
  contactType?: string;
  gapDays: number;
}

export enum StatementBillToFilterType {
  All = "ALL",
  Patient = "PAT",
  Organisation = "ORG"
}

export interface StatementExpanderButtonProps {
  endDate: StatementGenerateFormValues["endDate"];
  gapDays: StatementGenerateFormValues["gapDays"];
}
